module.exports = __webpack_public_path__ + "img/76.6a50e025.jpg";